export class Status {
  title: string
  icon: string
  classNames: string

  constructor ({ title = '', icon = '', classNames = '' }) {
    this.title = title
    this.icon = icon
    this.classNames = classNames
  }
}

const SESSION_STATUSES = new Map([
  [
    // Обучение ещё не начато.
    'pending',
    new Status({
      title: 'session_status_pending.one',
      classNames: '',
    })
  ],
  [
    // Обучение начато.
    'started',
    new Status({
      title: 'session_status_started.one',
      classNames: 'info--text',
    })
  ],
  [
    // Обучение пропущено.
    'skipped',
    new Status({
      title: 'session_status_skipped.one',
      classNames: 'warning--text',
    })
  ],
  [
    // Обучение завершено.
    'completed',
    new Status({
      title: 'session_status_completed.one',
      classNames: 'primary--text',
    })
  ],
  [
    // Обучение проверено, но результат не принят (отправлено на доработку).
    'evaluated',
    new Status({
      title: 'session_status_evaluated.one',
      classNames: 'error--text',
    })
  ],
  [
    // Обучение провалено.
    'rejected',
    new Status({
      title: 'session_status_rejected.one',
      classNames: 'error--text',
    })
  ],
  [
    // Обучение проверено и результат успешно принят.
    'accepted',
    new Status({
      title: 'session_status_accepted.one',
      classNames: 'success--text',
    })
  ],
])

const STEP_STATUSES = new Map([
  [
    'pending',
    new Status({
      title: 'step_status_pending.one',
      classNames: '',
    })
  ],
  [
    'started',
    new Status({
      title: 'step_status_started.one',
      classNames: 'info--text',
      icon: 'school'
    })
  ],
  [
    'skipped',
    new Status({
      title: 'step_status_skipped.one',
      classNames: 'warning--text',
      icon: 'cached'
    })
  ],
  [
    'completed',
    new Status({
      title: 'step_status_completed.one',
      classNames: 'primary--text',
      icon: '$uchi_schedule',
    })
  ],
  [
    'evaluated',
    new Status({
      title: 'step_status_evaluated.one',
      classNames: 'error--text',
      icon: 'priority_high',
    })
  ],
  [
    'rejected',
    new Status({
      title: 'step_status_rejected.one',
      classNames: 'error--text',
      icon: 'priority_high',
    })
  ],
  [
    'accepted',
    new Status({
      title: 'step_status_accepted.one',
      classNames: 'success--text',
      icon: 'done'
    })
  ],
  [
    'disabled',
    new Status({
      title: '',
      classNames: '',
      icon: 'lock',
    })
  ]
])

export const prepareStatus = (statuses: Map<string, Status>) => {
  if (!statuses.size) {
    return
  }

  return (code: string) => statuses.get(code)
}

export const prepareSessionStatus = prepareStatus(SESSION_STATUSES)
export const prepareStepStatus = prepareStatus(STEP_STATUSES)
